import { syncAPICall } from './instances/smartsolve';

export default function makeCachedSyncAPICall(cacheLifespanInMs = 1000) {
  const cache = {};

  return function cachedSyncAPICall(uri, params) {
    const cacheKey = JSON.stringify(params);

    if (cacheKey in cache) {
      return cache[cacheKey].response;
    }

    const response = syncAPICall(uri, params);

    cache[cacheKey] = { response };

    setTimeout(() => delete cache[cacheKey], cacheLifespanInMs);

    return response;
  };
}
